<template>
     <div class="q-pa-md">
        <div class="q-pa-md q-gutter-sm">
      <q-breadcrumbs>
         <q-breadcrumbs-el icon="home" to="/home" />
        <q-breadcrumbs-el
          label="Price Tracker"
          icon="widgets"
          to="/pricewatch/home"
        />
        <q-breadcrumbs-el
          label="Price Tracker Results"
          icon="widgets"
          to="/pricewatch/results"
        />
      </q-breadcrumbs>
    </div>
     <div class="introWindow">
       <div style="margin-bottom:15px">
         <button class="btn" style="display:inline-block;margin-left:65%">
           <router-link to="/pricewatch/product" style="text-decoration :none;color:white" >+ Add Product</router-link>
          </button> 
         <button class="btn" style="display:inline-block;margin-left:5px">Know More</button> 
       </div>

      <q-table
        
        ref="table"
        title="Price Tracker"
        :data="data"
        :columns="columns"
        row-key="product_name"
        no-data-label="No Result Found"
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              v-for="col in columns"
              :key="col.name"
              :props="props"
              class="headerText"
              :style="{ fontSize: '15px', color: 'rgb(37, 97, 165)' }"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
          <template v-slot:body="props" >
            <q-tr :props="props">
     <!--          <q-td key="index" :props="props">
                 1
            </q-td>
      -->
            <q-td key="product_name" :props="props">
               {{props.row.response_text[0]['product_name'].substring(0,70)}}
            </q-td>
            <q-td key="product_cost" :props="props">
                {{props.row.response_text[0]['product_cost']}} 
            </q-td>
            <q-td key="my_price" :props="props">
                 {{props.row.response_text[0]['user_price']}} 
            </q-td>
            <q-td key="cheapest_competitor" :props="props">
                {{props.row.response_text[0]['cheap_comp']}} 
            </q-td>
            <q-td key="average" :props="props">
                {{props.row.response_text[0]['avg']}} 
            </q-td>
            <q-td key="highest_competitor" :props="props">
                {{props.row.response_text[0]['high_comp']}} 
            </q-td>
            <q-td key="smart_price" :props="props">
                {{props.row.response_text[0]['smart_price']}} 
            </q-td>

            </q-tr>
          </template>
      </q-table>
    </div>
    </div>
</template>

<script>
export default {
  props: { jobid: String },

  data() {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      isLoading: true,
      errorcarbs: false,
      errorClassData: [],
      errorMessagecarbs: "",
      submitVisibliliy: true,
      backupList: [],

      columns: [
  /*      {
          name: "index",
          required: true,
          label: "Index",
          align: "center",
          field: "index",
     //    classes: "bg-grey-2 ellipsis",
     //     style: "max-width: 100px",
     //     headerClasses: "bg-primary text-white",         
          sortable: true,
        },
  */

        {
          name: "product_name",
          label: "Product Name",
          field: "product_name",
          align: "left",
        },
        {
          name: "product_cost",
          label: "Cost",
          field: "product_cost",
          align: "center",
          sortable: true,
        },
        {
          name: "my_price",
          label: "My Price",
          field: "my_price",
          align: "center",
          sortable: true,
        },
        {
          name: "cheapest_competitor",
          label: "Lowest",
          field: "cheapest_competitor",
          align: "center",
        },
         {
          name: "average",
          label: "Average",
          field: "average",
          align: "center",
        },
        {
          name: "highest_competitor",
          label: "Highest",
          field: "highest_competitor",
          align: "center",
        },
        {
          name: "smart_price",
          label: "Smart Price",
          field: "smart_price",
          align: "center",
        },
        
      ],
      filter: "",
      data: [],
    };
  },
 /*  created() {
    var resultshistoryURL = this.api_url + "/resultshistory/pricewatch_product_result";
    this.$http
      .get(resultshistoryURL)
      .then((response) => {
        let count=1;
        let result = response.data;
        let data = result.map((items) => {
          return {
            ...items,
          //  jobnum: count++
          };
        });
        
        console.log(data);
        this.data = data;
        this.isLoading = false;
     //   console.log(this.data.price_watch_details[1].product_name);
     //   console.log("price_watch_details " + this.props.row.price_watch_details);
      })
      .catch((err) => {
        this.$q.notify({
          message: err,
          color: "negative",
        });
        this.isLoading = false;
        // console.log(err);
      });
  },
  */
  mounted() {
    console.log(this.$route.params.jobid);
    var resultsURL =
      this.api_url +
      "/resultshistory/pricewatch_product_result"
    //  "/resultshistory/pricewatch_product_result/" +
    //  this.$route.params.jobid;
    console.log(resultsURL);
    this.$http
      .get(resultsURL)
      .then((response) => {
        let result = response.data;

        let data = result;

        this.data = data;
        console.log(this.data);
     //   this.isLoading = false;
      })
      .catch((err) => {
        this.$q.notify({
          message: err,
          color: "negative",
        });
     //   this.isLoading = false;
        //console.log(err);
      });
  },
}
</script>

<style scoped>
.btn{
    display:inline-block;
    background-color: rgb(37, 97, 165);
    border:1px solid rgb(37, 97, 165);
    border:0px;
 /*   margin:auto;    */
    width:10rem;
    margin-top:12px;
    margin-left:65%;
    font-size: 1.1rem;
    padding:0.2rem;
    border-radius: 5px;
    color:white;
    cursor:pointer;
    font-family: 'Baloo 2', cursive;
  }
</style>
